import React, { Suspense } from 'react';

import { Route, Redirect } from 'react-router-dom';

interface AuthLayoutProps {
  component: any;
  layout: any;
  isAuthProtected: any;
  path?: string;
  exact?: boolean;
  key?: number;
}

const Authmiddleware = ({
  component,
  layout,
  isAuthProtected,
  path,
  exact,
  key,
  ...rest
}: AuthLayoutProps) => {
  const Layout = layout;
  const Component = component;

  return (
    <Route
      {...rest}
      render={(props: any) => {
        if (isAuthProtected && !localStorage.getItem('authUser')) {
          const search = window.location.search;
          const params = new URLSearchParams(search).toString();
          const nwkID = (params ? `?${params}` : "");
          return (
            <Redirect
              to={{
                pathname: '/login',
                search: path === "/inactiveUsers" ? nwkID : "",
                state: { from: props.location }
              }}
            />
          );
        }

        return (
          <Layout>
            <Suspense fallback={<div>Loading...</div>}>
              <Component {...props} />
            </Suspense>
          </Layout>
        );
      }}
    />
  );
};

export default Authmiddleware;
